const TOKEN_KEY = 'norgas_token';
const USER_KEY = 'norgas_user';

// Phone-pairing child JWTs are stored in sessionStorage so closing the tab
// ends the phone's app-level session (the PairingToken itself stays valid
// for 8 hours on the server — reopen the QR/short-code to resume).
// localStorage is used for the primary PC/app session.
export function getToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY) ?? localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string, options?: { ephemeral?: boolean }): void {
  if (options?.ephemeral) {
    sessionStorage.setItem(TOKEN_KEY, token);
    // Clear any localStorage token so the two don't coexist and race.
    localStorage.removeItem(TOKEN_KEY);
  } else {
    localStorage.setItem(TOKEN_KEY, token);
    sessionStorage.removeItem(TOKEN_KEY);
  }
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
}

export function getStoredUser(): string | null {
  return sessionStorage.getItem(USER_KEY) ?? localStorage.getItem(USER_KEY);
}

export function setStoredUser(user: string, options?: { ephemeral?: boolean }): void {
  if (options?.ephemeral) {
    sessionStorage.setItem(USER_KEY, user);
    localStorage.removeItem(USER_KEY);
  } else {
    localStorage.setItem(USER_KEY, user);
    sessionStorage.removeItem(USER_KEY);
  }
}

export function isTokenExpired(expiresAt: string): boolean {
  return new Date(expiresAt) < new Date();
}
